/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAccount } from '../models/SourceAccount';

export class ListSourceAccountsResponse {
  /**
  * List of source accounts.
  */
  'accounts': Array<SourceAccount>;
  /**
  * Cursor that points to the first record of the next page of results. Pass this value in the next request. 
  */
  'nextToken'?: string;
  /**
  * Total number of source accounts that matched the filter options.
  */
  'totalCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accounts",
      "baseName": "accounts",
      "type": "Array<SourceAccount>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSourceAccountsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

